const actions = {
    RESET_CHATR_VALIDATE_MESSAGE: "RESET_CHATR_VALIDATE_MESSAGE",

    ADD_CHATR_BULK_ACTIVATION: "ADD_CHATR_BULK_ACTIVATION",
    ADD_CHATR_BULK_ACTIVATION_SUCCESS: "ADD_CHATR_BULK_ACTIVATION_SUCCESS",
    ADD_CHATR_BULK_ACTIVATION_FAILED: "ADD_CHATR_BULK_ACTIVATION_FAILED",

    GET_CHATR_ACTIVATION_REQUEST_LIST: "GET_CHATR_ACTIVATION_REQUEST_LIST",
    GET_CHATR_ACTIVATION_REQUEST_LIST_SUCCESSFUL: " GET_CHATR_ACTIVATION_REQUEST_LIST_SUCCESSFUL",
    GET_CHATR_ACTIVATION_REQUEST_LIST_FAILED: " GET_CHATR_ACTIVATION_REQUEST_LIST_FAILED",

    GET_CHATR_BATCHTRANSACTIONBYID_REQUEST: "GET_CHATR_BATCHTRANSACTIONBYID_REQUEST",
    GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL: "GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL",
    GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED: "GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED",

    RESET_CHATR_MESSAGES: 'RESET_CHATR_MESSAGES',

    resetChatrMessage: () => ({
        type: actions.RESET_CHATR_MESSAGES,
    }),

    getChatrBatchTransactionIdRequest: (data) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST,
        payload: { data },
    }),
    getChatrBatchTransactionIdRequestSuccessful: (result) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED,
        payload: { result },
    }),
    getChatrBatchTransactionIdRequestFailed: (error) => ({
        type: actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST_FAILED,
        error,
    }),

    getChatrActivationRequestList: (searchData) => ({
        type: actions.GET_CHATR_ACTIVATION_REQUEST_LIST,
        payload: { searchData }
    }),
    getChatrActivationRequestListSuccessful: (data) => ({
        type: actions.GET_CHATR_ACTIVATION_REQUEST_LIST_SUCCESSFUL,
        payload: { data }
    }),
    getChatrActivationRequestListFailed: (activationError) => ({
        type: actions.GET_CHATR_ACTIVATION_REQUEST_LIST_FAILED,
        payload: { activationError }
    }),

    addChatrBulkActivation: (data, searchData) => ({
        type: actions.ADD_CHATR_BULK_ACTIVATION,
        payload: { data, searchData }
    }),
    addChatrBulkActivationSuccess: (message) => ({
        type: actions.ADD_CHATR_BULK_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    addChatrBulkActivationFailed: (error) => ({
        type: actions.ADD_CHATR_BULK_ACTIVATION_FAILED,
        payload: { error }
    }),
    resetChatrValidateMessage: () => ({
        type: actions.RESET_CHATR_VALIDATE_MESSAGE,
    })
};
export default actions;
